export const uSubscriptionName = (subscription) => {
    switch (subscription) {
        case 0:
            return 'Grátis';
        case 1:
            return 'Mensal';
        case 2:
            return 'Anual à Vista';
        case 3:
            return 'Anual Parcelado (Assinatura)';
        default:
            return '-';
    }
};

export const uSubscriptionExpiration = (releasedDeadline) => {
    if (!releasedDeadline) {
        return '-';
    }
    
    const expDate = new Date(releasedDeadline).toLocaleDateString();
    const now = new Date();
    const valid = new Date(expDate);
    const diff = valid - now;
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

    if (days < 0) {
        return 'Expirado';
    } else {
        return releasedDeadline + ' (' + days + 'd)';
    }
};

export const uSearchesRemaining = (searches) => {
    return 5 - searches;
};